import moment, { Moment } from "moment-timezone";
import ApiDateParser from "../helpers/parsers/apiDateParser";
import {
  DaysOfTheWeekType,
  WeeklySessionsScheduleResponse,
} from "../api/@types/apiResponseTypes";
import { SessionsWeeklySchedule } from "../models/SessionsWeeklySchedule";
import ScheduledSession from "../models/ScheduledSession";

export type SlotOnDay = {
  startTime: Moment;
  endTime: Moment;
};

export function adjustScheduleToCurrentTimezone(
  schedule: WeeklySessionsScheduleResponse
): SessionsWeeklySchedule {
  const adjustedSchedule = new SessionsWeeklySchedule();
  Object.keys(schedule).forEach((day: string) => {
    const dayOfTheWeek = day as DaysOfTheWeekType;
    const slots = schedule[dayOfTheWeek]!;

    slots.forEach((slot) => {
      const generatedSlot = generateRelativeSessionFromDayOfTheWeekSlot(
        slot.start_time,
        slot.end_time,
        dayOfTheWeek
      );
      const session = new ScheduledSession({
        startTime: generatedSlot.startTime,
        endTime: generatedSlot.endTime,
        sessionNumber: slot.session_number,
        sessionType: slot.schedule_slot_type,
        sessionId: slot.session_id,
        sessionStatus: slot.session_status,
        student: slot.student,
        slotDBId: slot.schedule_slot.id,
      });
      adjustedSchedule.addSessionOnDate(session);
    });
  });

  return adjustedSchedule;
}

export function generateRelativeSessionFromDayOfTheWeekSlot(
  startTime: string,
  endTime: string,
  dayOfTheWeek: DaysOfTheWeekType
): SlotOnDay {
  // There is potential for a bug here where the week reference is incorrect when the UTC offset is removed or added from the current date
  // Specially if the date was at the beginning or at the end of the week
  const currentWeekUTCreference = moment().utc();
  const dayOfTheWeekDateRelativeToCurrentWeek =
    dayOfTheWeekDateRelativeToReferenceWeek(
      currentWeekUTCreference,
      dayOfTheWeek
    );
  const startTimeParsedLocal = ApiDateParser.combinedDateTimeParseLocal(
    dayOfTheWeekDateRelativeToCurrentWeek.toISOString(),
    startTime
  );
  const endTimeParsedLocal = ApiDateParser.combinedDateTimeParseLocal(
    dayOfTheWeekDateRelativeToCurrentWeek.toISOString(),
    endTime
  );

  return {
    startTime: startTimeParsedLocal,
    endTime: endTimeParsedLocal,
  };
}

export function dayOfTheWeekDateRelativeToReferenceWeek(
  referenceDate: Moment,
  dayOfTheWeek: DaysOfTheWeekType
) {
  const weekStart = referenceDate.clone().startOf("week");
  const weekEnd = referenceDate.clone().endOf("week");

  const datesHash: Record<string, Moment> = {};
  const startDate = weekStart.clone();
  while (startDate.isBefore(weekEnd)) {
    const dayName = startDate.locale("en").format("dddd").toLocaleLowerCase();
    datesHash[dayName] = startDate.clone();
    startDate.add(1, "day");
  }
  return datesHash[dayOfTheWeek];
}
